export default __webpack_public_path__ + "static/media/payment.0d58c4a0.svg";